// adding value not equal to for select boxes

const rule = {
	name: 'valueNotEqualTo',
	method: (value, element, params) => value != params,
	errorMessage: (params, element) => 'Please make a selection'
};

export default rule;
